import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import QuoteForm from '../../../components/base/QuoteForm';

const SeamlessGuttersPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Custom <strong>Seamless Gutters</strong> in <strong>Northwest Arkansas</strong>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Protect your <strong>Fayetteville, Rogers, Bentonville, or Springdale</strong> home with professionally installed <strong>seamless gutter systems</strong>. Custom-made on-site for perfect fit.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                  <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565
                </a>
                <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 border-2 border-teal-600 px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                  Get Free Estimate
                </a>
              </div>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://public.readdy.ai/ai/img_res/287353841978fa124b6086dfe0b60dda.jpg"
                alt="Seamless gutter installation"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Seamless */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Why Choose <strong>Seamless Gutters</strong>?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Superior protection for your <strong>Northwest Arkansas</strong> home
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-drop-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>No Leaks</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Continuous construction eliminates seams and joints where traditional gutters leak and fail.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-ruler-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Custom Fit</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Made on-site to your home's exact measurements for perfect fit and optimal water flow.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-palette-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Beautiful Appearance</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Clean, streamlined look enhances your home's curb appeal with no unsightly seams or joints.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-time-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Long-Lasting</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Durable aluminum construction resists rust, corrosion, and weather damage for decades.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-tools-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Low Maintenance</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Fewer joints mean less debris accumulation and easier cleaning when needed.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-home-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Increases Home Value</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Quality gutter system is a valuable upgrade that protects your investment and appeals to buyers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Our <strong>Seamless Gutter</strong> Installation Process
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                1
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Free Inspection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We measure your home, assess your needs, and provide a detailed quote with color options.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                2
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Old Gutter Removal</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We carefully remove your old gutters and inspect fascia boards for any damage or rot.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                3
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Custom Fabrication</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We create your gutters on-site using our professional gutter machine for perfect fit.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                4
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Professional Install</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We securely install gutters and downspouts with proper pitch for optimal water flow and drainage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Ready for <strong>Seamless Gutters</strong>?
            </h2>
            <p className="text-xl mb-8 text-teal-50">
              Contact <strong>NWA Gutter Guards</strong> today for a free estimate on <strong>seamless gutter installation</strong> in <strong>Northwest Arkansas</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg whitespace-nowrap min-h-[56px]">
                <i className="ri-phone-line mr-2"></i> Call (479) 337-7565
              </a>
              <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-50 transition-all whitespace-nowrap min-h-[56px]">
                Request Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SeamlessGuttersPage;